/* eslint-disable jsx-a11y/label-has-associated-control */

function RadioButton({ checked, blue }) {
    return (
        <div className={`input-radio ${blue ? 'blue-variant' : ''}`}>
            <input type="radio" checked={checked} readOnly />
            <label htmlFor="radio" />
        </div>
    );
}

export default RadioButton;
